<template>
  <div class="d-theme-dark-bg">
    <vs-tabs>
      <vs-tab label="packages & Channels">
        <div class="con-tab-ejemplo">
          <packagesVue/>
        </div>
      </vs-tab>
      <vs-tab label="Schedule">
        <div class="con-tab-ejemplo">
          <scheduleVue/>
        </div>
      </vs-tab>
      <vs-tab label="Slider">
        <div class="con-tab-ejemplo">
          <sliderVue/>
        </div>
      </vs-tab>

    </vs-tabs>
 
  </div>
</template>
<script>
import packagesVue from './packages.vue';
import scheduleVue from './schedule.vue';
import sliderVue from './slider.vue';
 
 
export default {
  components:{packagesVue,scheduleVue,sliderVue}
}
</script>